import Vue from 'vue'
import ElementUI from 'element-ui'//element-ui
import 'element-ui/lib/theme-chalk/index.css'//element-ui
import App from './App.vue'
import router from './router'
import './assets/gloable.css'
import request from '@/utils/request'
import store from './store/index'


Vue.config.productionTip = false
Vue.use(ElementUI,{size:"medium"});// element-ui

// Vue.use(ElementUI, { locale })

Vue.prototype.request = request

new Vue({
  router,
  store,//定义成全局变量
  render: h => h(App)
}).$mount('#app')
